import { adminCashMonitorApi } from "../../api";
import { AdminCashRegisterMonitorDTO } from "../../types/cash/adminCashMonitor";
import { AdminCashRegisterHistoryItemDTO } from "../../types/cash/adminCashMonitorHistory";

const AdminCashMonitorService = {
  /**
   * 🏢 Cajas de una sucursal con su estado en vivo (Corte X) o su
   * último cierre (Corte Z) — panel administrativo de monitoreo.
   * GET /api/admin/cash-monitor/branches/{branchId}/registers
   */
  getRegistersByBranch: async (
    branchId: number
  ): Promise<AdminCashRegisterMonitorDTO[]> => {
    const response = await adminCashMonitorApi.fetchCustom(
      `/branches/${branchId}/registers`
    );
    return response.data?.data ?? [];
  },

  /**
   * 📜 Historial de sesiones de una caja (apertura → cierre).
   * GET /api/admin/cash-monitor/registers/{registerId}/history
   */
  getRegisterHistory: async (
    registerId: number
  ): Promise<AdminCashRegisterHistoryItemDTO[]> => {
    const response = await adminCashMonitorApi.fetchCustom(
      `/registers/${registerId}/history`
    );
    return response.data?.data ?? [];
  },
};

export default AdminCashMonitorService;
